import { render, staticRenderFns } from "./Exercise2-1.vue?vue&type=template&id=e98df086&"
import script from "./Exercise2-1.vue?vue&type=script&lang=js&"
export * from "./Exercise2-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports